module.exports = __webpack_public_path__ + "static/img/49058de34b03f4f93755a64b9700ff98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_icon3.png
// module id = J75j
// module chunks = 1